var map = {
	"./BRONZE.png": 8666,
	"./CHALLENGER.png": 6206,
	"./DIAMOND.png": 1073,
	"./EMERALD.png": 5835,
	"./GOLD.png": 3653,
	"./GRANDMASTER.png": 7371,
	"./IRON.png": 6964,
	"./MASTER.png": 9531,
	"./PLATINUM.png": 7533,
	"./SILVER.png": 6043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8756;